<script setup lang="ts">
import DateField from '@/components/forms/DateField.vue';
import { useDisplay } from 'vuetify';

const text = defineModel();

const props = withDefaults(
    defineProps<{
        label: string;
        type?: 'text' | 'password' | 'date';
        isReadonly?: boolean;
        includeTime?: boolean;
        min?: string;
        max?: string;
        rules?: ((value: any) => string | boolean)[];
        required?: boolean;
        readonly?: boolean;
    }>(),
    {
        type: 'text',
        required: false,
        rules: () => [],
        readonly: false
    }
);

const { smAndDown } = useDisplay();
</script>

<template>
    <v-row class="justify-sm-space-between my-0 align-center">
        <v-col cols="5">
            <label :for="props.label">{{ props.label }}</label>
        </v-col>
        <v-col md="4" cols="7">
            <DateField v-if="props.type === 'date'" v-model="text" :id="props.label" v-bind="props" />
            <v-text-field
                v-else
                v-model="text"
                v-bind="props"
                :id="props.label"
                :hide-details="smAndDown ? 'auto' : false"
                :class="smAndDown && 'ga-3'"
                :readonly="props.readonly"
            />
        </v-col>
    </v-row>
</template>

<style scoped>
label {
    font-weight: bold;
    font-size: 18px;
}

:deep(.v-input__control) {
    .v-field__input[readonly] {
        cursor: not-allowed;
    }
}
</style>
